import bg from "assets/images/main-slider/banner-bg-shape-3.png";

export const bannerTwo = [
  {
    id: 1,
    bg: "bg-2.jpg",
    subtitle: "welcome to Bounty Group ZA",
    title: "The Sky Shouldn't\nBe The Limit",
  },
  {
    id: 2,
    bg: "bg-4.jpg",
    subtitle: "Bounty Group ZA is",
    title: "Trusted By The Best Digital\nBrands",
  },
  {
    id: 3,
    bg: "bg-3.jpg",
    subtitle: "Providing a",
    title: "Variety Of\nProducts And Services",
  },
  {
    id: 4,
    bg: "bg-1.jpg",
    subtitle: "To",
    title: "Thousands Of Happy Customers\n And Growing...",
  },
];

export const bannerOne = {
  bg,
  dayRange: "mon - fri",
  timeRange: "9am - 5pm",
  socials: [
    {
      id: 1,
      href: "#",
      title: "Twitter",
    },
    {
      id: 2,
      href: "#",
      title: "Facebook",
    },
    {
      id: 3,
      href: "#",
      title: "Youtube",
    },
  ],
  banners: bannerTwo,
  bannersTwo: [
    {
      id: 1,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "We are committed to providing our customers with exceptional service while offering our employees the best training.",
    },
    {
      id: 2,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "We are committed to providing our customers with exceptional service while offering our employees the best training.",
    },
    {
      id: 3,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "We are committed to providing our customers with exceptional service while offering our employees the best training.",
    },
    {
      id: 4,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "We are committed to providing our customers with exceptional service while offering our employees the best training.",
    }
  ],
};

export const bannerOnePage = [
  {
    id: 1,
    bg: "2-1.jpg",
    subtitle: "welcome to Bounty Group ZA",
    title: "new Bounty Group ZA",
    videoId: "Get7rqXYrbQ",
  },
  {
    id: 2,
    bg: "2-2.jpg",
    subtitle: "welcome to Bounty Group ZA",
    title: "new Bounty Group ZA",
    videoId: "Get7rqXYrbQ",
  },
];

export const bannerSectionFour = [
  {
    id: 1,
    bg: "main-slider-1-1.jpg",
    title: "We Combine Tech With Business",
    text: "Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia \n deserunt mollit anim id est laborum.",
  },
  {
    id: 2,
    bg: "main-slider-1-2.jpg",
    title: "We Combine Tech With Business",
    text: "Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia \n deserunt mollit anim id est laborum.",
  },
];

export const bannerFour = {
  dayRange: "mon - fri",
  timeRange: "9:00 am - 7:00 pm",
  title: "building a digital products \n for our customers.",
  text: " welcome to linoor digital agency services",
  socials: [
    {
      id: 1,
      icon: "fab fa-facebook-f",
      href: "#",
    },
    {
      id: 2,
      icon: "fab fa-twitter",
      href: "#",
    },
    {
      id: 3,
      icon: "fab fa-pinterest-p",
      href: "#",
    },
    {
      id: 4,
      icon: "fab fa-instagram",
      href: "#",
    },
  ],
};
